module.exports = __webpack_public_path__ + "static/media/NewGooglePin.77c8ed0d.png";